import React from 'react';
import { OrderItemsProps } from './types';
import AloStaticSnackbar from 'src/scripts/templates/_shared/ui-components/YogaUI/alo-ui/AloStaticSnackbar';
import BrandingPageLineItem from './BrandingPageLineItem';
import './styles.scss';
import { getOrderUrl } from './utils';
import { prependLocaleToPath } from 'src/scripts/utils/localization';

const OrderItems = ({
  orderReference,
  orderStatusUrl = '',
  lineItems = [],
  authParam,
  isError = false,
}: OrderItemsProps) => {
  const shouldShowError = isError || !lineItems?.length;

  const orderUrl = getOrderUrl(orderStatusUrl, orderReference, authParam);

  return (
    <div className="order-items-container d-flex flex-column align-items-center p-xl">
      <h4 className="text-center">ITEMS IN THIS SHIPMENT</h4>
      <div className={`items-list-wrapper ${shouldShowError ? 'mt-lg' : 'mt-3xl'} mb-lg`}>
        <div className="items-list d-flex flex-column">
          {shouldShowError ? (
            <AloStaticSnackbar message="Unable to load products. Check back soon." type="error" />
          ) : (
            <>
              {lineItems.map((item, index) => (
                <BrandingPageLineItem key={`${item.sku}-${index}`} item={item} />
              ))}
            </>
          )}
        </div>
      </div>
      <a role="button" href={prependLocaleToPath(orderUrl)} className="button-primary-md view-order-cta">
        VIEW ORDER
      </a>
    </div>
  );
};

export default OrderItems;
